import React, { useEffect, useState, useRef } from 'react'

import _ from 'lodash';
import cx from 'classnames';
import Fonts from '../../../../fonts';
import { InputGroup, Form, Button } from 'react-bootstrap';

import Content from '../../../../widgets/core/content';
import { CONTENT } from '../../../../../constants/widgetTypes';

import { useParentWidgetSelectorForType } from '../../../../widgets/core/hooks';
import { getBoxShadow } from '../../../../../services/cssHelper.service';
import { getColorsConfig } from '../../../../../components/AssetViewer/helper/cssHelper';

import styles from './searchBox.module.scss';

const SearchComponent = ({ className, widgetProps, breakpoint, parentProps }) => {
  const contentContext = React.useContext(Content.Context);
  const id = _.get(widgetProps, 'uid');

  const properties = _.get(widgetProps, 'properties', {});
  const [value, setValue] = useState('');
  const placeholder = _.get(widgetProps, 'properties.desktop.placeholder') || "";
  const searchIconColor = getColorStyles(_.get(widgetProps, 'properties.desktop.searchIconColor'))
  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  const itemsPerPage = _.get(contentWidget, 'properties.desktop.layoutStyle.itemsPerPage', 3);

  var inputWrapperStyles = getInputWrapperStyles(properties);
  var placeholderStyle = getPlaceholderStyle(properties);
  var inputFieldStyle = getInputFieldStyles(properties);

  const handleSearchOnChange =(e)=> {
    setValue(e.target.value);
    contentContext.updateQueryInContenGrid(contentWidget.uid, e.target.value)
    if (_.isEmpty(e.target.value)) {
      executeSearchAsset()
    }
  }

  const executeSearchAsset =()=> {
    if(contentWidget.uid) {
      contentContext.fetchMappingsForContentGrid(contentWidget.uid, 0, itemsPerPage);
    }
  }

  return (
    <InputGroup style={inputWrapperStyles} className={cx(styles.assetSearchBox, className)}>
      {placeholderStyle &&
        <style>
          {`
            #${id} input::-webkit-input-placeholder {
              color: ${placeholderStyle.color};
              font-family: ${placeholderStyle.fontFamily}
            }
          `}
        </style>
      }
      <i style={searchIconColor} className={cx('cleverstory-search', styles.searchIcon)} />
      <input type='text'
        placeholder={placeholder}
        style={inputFieldStyle}
        className={styles.inputField}
        value={value}
        onChange={handleSearchOnChange}
        onKeyPress={(event)=>{
          if (event.key === 'Enter') {
            contentContext.fetchMappingsForContentGrid(contentWidget.uid, 0, itemsPerPage)
          }
        }}
        disabled={false}
      />
      <SearchButtonWidget
        breakpoint={breakpoint}
        widgetProps={widgetProps}
        onClick={executeSearchAsset}
      />
    </InputGroup>
  )
}

const SearchButtonWidget = ({ breakpoint, widgetProps, onClick}) => {
  const [buttonStyles, setButtonStyles] = useState({});

  Fonts.useFont(_.get(widgetProps, 'fonts') || []);
  const properties = _.get(widgetProps, 'properties', {});

  useEffect(() => {
    updateButtonStyles('regular');
  }, [breakpoint, widgetProps]);

  const updateButtonStyles = (state) => {
    const updatedStyles = getButtonStyles(properties, state);
    setButtonStyles(updatedStyles);
  }

  return (
    <Button 
    className={styles.searchButton} 
    style={buttonStyles}
    variant="secondary" 
    id="search_button"
    onClick={onClick}
    onMouseOver={() => updateButtonStyles('hover')}
    onMouseOut={() => updateButtonStyles('regular')}
    >
      Search
    </Button>
  )
}


const searchComponentEquals = function (prevProps, nextProps) {
  const paths = ['className', 'widgetProps', 'breakpoint'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}


/**
 * --------------------------------------------------
 * Input Styles
 * -------------------------------------------------- 
*/

export function getInputFieldStyles(properties) {
  var inputstyles = {};

  if (!properties) {
    return inputstyles;
  }

  const defaultProperties = _.get(properties, `desktop`);

    const inputStyles = _.get(defaultProperties, 'font');
  const fontStyles = getFontStyle(inputStyles);

  inputstyles = {
    ...inputstyles,
    ...fontStyles
  }

  //font-color
  const colorRgb = _.get(defaultProperties, 'inputTextColor', null);
  const color = getColorStyles(colorRgb);
  inputstyles = {
    ...inputstyles,
    ...color
  }

  //font-family
  const fontFamily = _.get(defaultProperties, 'font.fontFamily', 'inherit');
  inputstyles = {
    ...inputstyles,
    fontFamily: fontFamily
  }

  //font-size
  const fontSizeString = _.get(defaultProperties, `font.fontSize`) || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    inputstyles['fontSize'] = fontSize;
  }

  return inputstyles;
}


function getInputWrapperStyles(properties) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const defaultProperties = _.get(properties, `desktop`);

  const inputPadding = _.get(defaultProperties, 'padding') || 0;

  if (inputPadding) {
    styles['padding'] = `0px ${inputPadding}px`;
  }

  const border = _.get(defaultProperties, 'border');
  const borderStyles = getBorderStyles(border);

  styles = {
    ...styles,
    ...borderStyles
  }

  //background-color
  const backgroundColorRgb = _.get(defaultProperties, 'background', null);
  if (backgroundColorRgb) {
    styles = {
      ...styles,
      background: getColorsConfig(backgroundColorRgb)
    }
  }

  return styles;
}

/**
 * --------------------------------------------------
 * Placeholder Styles
 * -------------------------------------------------- 
*/
export function getPlaceholderStyle(properties) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const defaultProperties = _.get(properties, `desktop`);
  const font = _.get(defaultProperties, 'font', {});


  const colorRgb = _.get(defaultProperties, 'placeholderColor', null);
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }

  var styles = {
    ...styles,
    color: color
  };


  //font-family
  const fontFamily = _.get(font, 'fontFamily');
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: fontFamily
    }
  }

  return styles;
}

export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }

  var styles = {
    ...styles,
    color: color
  };

  return styles;
}

export function getBorderStyles(border) {
  var styles = {};
  if (!border) {
    return styles;
  }

  const topLeft = _.get(border, 'radius.topLeft', null);
  const topRight = _.get(border, 'radius.topRight', null);
  const bottomLeft = _.get(border, 'radius.bottomLeft', null);
  const bottomRight = _.get(border, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  const borderStyle = _.get(border, 'style') || 'all';
  if (borderStyle !== 'none') {
    const borderWidthString = _.get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';

    const fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;

    const colorRgb = _.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }

    styles['borderColor'] = color;
  }

  return styles;
}

// button styles

function getButtonStyles(properties, active) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const defaultProperties = _.get(properties, `desktop`);
  const defaultStyles = _.get(defaultProperties, `buttonStyles.regular`, {});

  //font-color
  const colorRgb = _.get(defaultProperties, `buttonStyles.${active}.font.color`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    ...color
  }

  //background
  const backgroundRgb = _.get(defaultProperties, `buttonStyles.${active}.background`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }

  styles['background'] = background;

  const font = _.get(defaultStyles, 'font', {});

  //font-family
  const fontFamily = _.get(font, 'fontFamily');
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: fontFamily
    }
  }

  //font-size
  const fontSizeString = _.get(defaultProperties, 'buttonStyles.regular.font.fontSize', null);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  styles['fontSize'] = fontSize;

  //line spacing
  const lineSpacingString = _.get(defaultProperties, 'buttonStyles.regular.font.lineSpacing', null);
  if (lineSpacingString) {
    const lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }

  //Letter Spacing
  const letterSpacingString = _.get(defaultProperties, 'buttonStyles.regular.font.letterSpacing', null);
  if (letterSpacingString) {
    const letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }

  //font-style
  const bold = _.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }

  const italic = _.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }

  const underline = _.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }

  //border
  const border = _.get(defaultStyles, 'border', {});
  const borderColor = _.get(defaultProperties, `buttonStyles.${active}.border.color`, null);

  const borderStyle = getBorderStyles(border, borderColor);
  styles = {
    ...styles,
    ...borderStyle
  }

  //DropShadow
  const shadow = _.get(defaultProperties, `buttonStyles.${active}.shadow`, null);
  const shadowStyle = getBoxShadow(shadow);
  styles = {
    ...styles,
    ...shadowStyle
  }

  // //alignment
  // const alignment = _.get(deviceProperties, 'alignment', {});

  // var position = _.get(alignment, 'position', 'center');
  // styles['justifyContent'] = position;
  // styles['textAlign'] = position;

  // var margin = _.get(alignment, 'margin', 0);
  // if (position === 'left') {
  //   styles = {
  //     ...styles,
  //     paddingLeft: `${margin}px`
  //   }
  // } else if (position === 'right') {
  //   styles = {
  //     ...styles,
  //     paddingRight: `${margin}px`
  //   }
  // }

  return styles;
}

export function getFontStyle(fontStyles) {
  var styles = {};

  if (!fontStyles) {
    return styles;
  }

  //font-color
  const colorRgb = _.get(fontStyles, 'color', null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    ...color
  }

  //font-family
  const fontFamily = _.get(fontStyles, 'fontFamily', 'inherit');
  styles = {
    ...styles,
    fontFamily: fontFamily
  }

  //font-size
  const fontSizeString = _.get(fontStyles, `fontSize`) || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }

  return styles;
}

export const AssetSearchBox = React.memo(SearchComponent, searchComponentEquals);